import { Translate } from '@change-corgi/core/react/i18n';
import { Image } from '@change-corgi/design-system-legacy/components/media';
import { Box, Flex } from '@change-corgi/design-system-legacy/layout';
import { Text } from '@change-corgi/design-system-legacy/typography';

import { SharePetitionButton } from './components/SharePetitionButton';
import { useShareSocial } from './hooks/useShareSocial';

export function ShareSocial() {
	const { data } = useShareSocial();

	return (
		<Flex
			p={16}
			backgroundColor="primary-greyBackground"
			sx={{
				alignItems: ['stretch', 'stretch', 'center'],
				borderRadius: 'standard',
				flexDirection: ['column', 'column', 'row'],
				flex: '1 1 auto',
				flexWrap: 'wrap',
				gap: 16,
			}}
		>
			<Box sx={{ flexBasis: ['auto', 'auto', '50%'], flexGrow: 1 }}>
				<Flex sx={{ alignItems: 'center', gap: 16 }}>
					<picture>
						<source
							type="image/webp"
							srcSet="https://static.change.org/images/share-media-1x.webp 1x, https://static.change.org/images/share-media-2x.webp 2x"
						/>
						<Image
							src="https://static.change.org/images/share-media-1x.png"
							srcSet="https://static.change.org/images/share-media-1x.png 1x, https://static.change.org/images/share-media-2x.png 2x"
							alt=""
							sx={{ minWidth: 48, width: 48 }}
						/>
					</picture>
					<Text breakWord size="small">
						<Translate
							value={`corgi.petition.starter_dashboard.grow_petition.share_petition.${data.shareVisual.enabled ? 'share_visuals_description' : 'share_description'}`}
						/>
					</Text>
				</Flex>
			</Box>
			<Flex sx={{ flexDirection: 'column', flexGrow: 1, gap: 16, ml: [null, null, 'auto'] }}>
				<SharePetitionButton />
			</Flex>
		</Flex>
	);
}
